import req from './http'

export default {
    getAppApkVersion:()=>req('get',"/apk/url"),
    getPoblemList:()=>req('get','/help/list'),
    getPoblemDetai : param=>req('get','/help/info',param),
    putPoblemDetai : param=>req('put','/help/info',param),
    setProcess : param=>req('post','/care/user',param),
    setShare : param=>req('post','/h5/login',param),
    upImgCom : param=>req('post','/upload/img',param)
}